import { Container, DependencyContainerContext } from "@meraki-internal/react-dependency-injection";
import { ClubsState, ClubState } from "./ClubsState";

export class ClubStateContainerContext extends DependencyContainerContext {
    containerMounted = (container: Container) => {
        const { clubId } = this.props;
        const clubs = container.get(ClubsState);
        container.registerInstance(ClubState, clubs.getClubState(clubId));
    };
}